// Mirrors backend/services/crm_health.py status values.
export const HEALTH_META = {
    overdue: { label: "Overdue", color: "#dc2626", bg: "rgba(220,38,38,0.1)" },
    never: { label: "Never contacted", color: "#b91c1c", bg: "rgba(185,28,28,0.1)" },
    due_soon: { label: "Due soon", color: "#d97706", bg: "rgba(217,119,6,0.12)" },
    ok: { label: "On track", color: "#00853F", bg: "rgba(0,133,63,0.1)" },
    off: { label: "Not tracked", color: "#64748b", bg: "rgba(100,116,139,0.1)" },
};

export function healthMeta(status) {
    return HEALTH_META[status] || HEALTH_META.off;
}

export function needsContact(h) {
    return h && (h.status === "overdue" || h.status === "never");
}

export function daysAgo(days) {
    if (days === null || days === undefined) return "never";
    if (days <= 0) return "today";
    if (days === 1) return "yesterday";
    return `${days}d ago`;
}

export function healthLine(h) {
    if (!h) return "";
    if (h.status === "off") return h.last_contact_at ? `Last contact ${daysAgo(h.days_since_contact)}` : "Contact not tracked";
    if (h.status === "never") return `Never contacted · ${h.days_overdue}d past the ${h.cadence_days}-day cadence`;
    if (h.status === "overdue") return `No contact for ${h.days_since_contact}d · ${h.days_overdue}d overdue (every ${h.cadence_days}d)`;
    if (!h.last_contact_at) return `Not contacted yet · due within ${h.cadence_days}d of being added`;
    return `Last contact ${daysAgo(h.days_since_contact)} · every ${h.cadence_days}d`;
}

export const STAGE_LABELS = {
    lead: "Lead", contacted: "Contacted", proposal: "Proposal", negotiation: "Negotiation",
    won: "Supplier list", active: "Active", closed_lost: "Lost",
};

export const CADENCE_CHOICES = [7, 14, 21, 30, 45, 60, 90];
